module.exports = __webpack_public_path__ + "img/112023.20862308.png";